module.exports = __webpack_public_path__ + "fa7ba48a09fb91dfe32f8576008ec1bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/letters/2.png
// module id = 3423
// module chunks = 0